import values from 'lodash/values';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';

import { jeCSS } from '../../lib/StyleUtils';

import './ButtonLink.scss';

export const ButtonLinkStyles = Object.freeze({
  NAV: 'nav',
  NAV_SIGNUP_DARKTHEME: 'nav--signUp--darkTheme',
  NAV_LOGIN_DARKTHEME: 'nav--login--darkTheme',
  NAV_LOGIN_ONBOARDING: 'nav--login--onboarding',
  NAV_UPGRADE_DARKTHEME: 'nav--upgrade--darkTheme',
  NAV_SIGNUP_LIGHTTHEME: 'nav--signUp--lightTheme',
  NAV_LOGIN_LIGHTTHEME: 'nav--login--lightTheme',
  NAV_UPGRADE_LIGHTTHEME: 'nav--upgrade--lightTheme',
  NAV_LOGIN_ANON: 'nav--login--anonymous',
  NAV_BLUEBAR: 'nav--blueBar',
  CTA_LIGHTTHEME: 'cta--lightTheme',
  CTA: 'cta',
  CTA_WHITE: 'cta--white',
  CTA_T3: 'cta--t3',
  WIDE: 'wide',
});

class ButtonLink extends React.Component {
  /**
   * @property {string} title - message, with id and defaultMessage, that renders in the button
   * @property {string} to - relative url path
   * @property [Array] styleNames - options classes to be applied to the button.
   * @property {string} qaTag - QA tag to be applied to this element.
   * @property {object} intl - the text to render in the button.
   * @property {boolean} externalLink - if true, will render the button as an <a> tag that redirects outside of app.
   * @property {Function} handleClick - if included, will call function on button click.
   */
  static propTypes = {
    title: PropTypes.object.isRequired,
    to: PropTypes.string.isRequired,
    styleNames: PropTypes.arrayOf(PropTypes.oneOf(values(ButtonLinkStyles))),
    qaTag: PropTypes.string,
    intl: PropTypes.object,
    externalLink: PropTypes.bool,
    openInNewTab: PropTypes.bool,
    handleClick: PropTypes.func,
    query: PropTypes.object,
  };

  static defaultProps = {
    styleNames: [],
  };

  render() {
    if (this.props.openInNewTab) {
      return (
        <a
          onClick={this.props.handleClick}
          className={`${jeCSS('ButtonLink', this.props.styleNames)}`}
          target='_blank'
          href={this.props.to}
          data-qa={this.props.qaTag}
          rel='noreferrer'
        >
          <FormattedMessage {...this.props.title} />
        </a>
      );
    }

    if (this.props.externalLink) {
      return (
        <a
          onClick={this.props.handleClick}
          className={`${jeCSS('ButtonLink', this.props.styleNames)}`}
          href={this.props.to}
          data-qa={this.props.qaTag}
        >
          <FormattedMessage {...this.props.title} />
        </a>
      );
    }

    return (
      <Link
        onClick={this.props.handleClick}
        className={`${jeCSS('ButtonLink', this.props.styleNames)}`}
        to={{
          pathname: this.props.to,
          state: {
            upgradeClickedFromTopNav: true,
            title: this.props.title.defaultMessage,
          },
        }}
        data-qa={this.props.qaTag}
        query={this.props.query}
      >
        <FormattedMessage {...this.props.title} />
      </Link>
    );
  }
}

export default ButtonLink;
export { ButtonLink as PureButtonLink };
